export function formatPhoneNumber(phone: string): string {
  // Use non-breaking space (NBSP)
  const NBSP = '\u00A0'

  // Remove any non-numeric characters except '+'
  const cleaned = phone?.replace(/[^\d+]/g, '')

  // Check for Uzbekistan (+998) - Mobile only
  if (/^\+998\d{9}$/.test(cleaned)) {
    return cleaned?.replace(
      /(\+998)(\d{2})(\d{3})(\d{2})(\d{2})/,
      `$1${NBSP}$2${NBSP}$3${NBSP}$4${NBSP}$5`
    )
  }

  // Check for Kazakhstan (+7) - Mobile and Landline
  if (/^\+7\d{10}$/.test(cleaned)) {
    return cleaned?.replace(
      /(\+7)(\d{3})(\d{3})(\d{2})(\d{2})/,
      `$1${NBSP}$2${NBSP}$3${NBSP}$4${NBSP}$5`
    )
  }

  // Check for Czech Republic (+420)
  if (/^\+420\d{9}$/.test(cleaned)) {
    // Mobile format: +420 XXX XXX XXX
    return cleaned?.replace(
      /(\+420)(\d{3})(\d{3})(\d{3})/,
      `$1${NBSP}$2${NBSP}$3${NBSP}$4`
    )
  } else if (/^\+420\d{8}$/.test(cleaned)) {
    // Landline format: +420 XX XXX XXXX
    return cleaned?.replace(
      /(\+420)(\d{2})(\d{3})(\d{4})/,
      `$1${NBSP}$2${NBSP}$3${NBSP}$4`
    )
  }

  return ''
}
